var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12",attrs:{"id":"content-areas"}},[(_vm.data)?_c('bar-chart',{attrs:{"chartdata":_vm.data}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }